import { useCallback, useLayoutEffect, useMemo } from 'react'

import { BTN_TXT, VALIDATION_MESSAGES } from 'constants/txt'
import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { Button, BUTTON_TYPES } from 'components/Button'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { useContractDetailsPopup } from 'features/ContractDetails/Providers/ContractDetailsPopupProvider'
import { setLoading } from '../../../../redux/store/common/slice'
import { updateContractTerminationDateRequestAsync } from '../../api'
import moment from 'moment/moment'
import { useDispatch } from 'react-redux'
import { notification } from '../../../../components/Notification'
import { AxiosResponse } from 'axios'

export default () => {
  const dispatch = useDispatch()
  const contractDetailsContext = useContractDetailsContext()
  const { terminateContractPopup } = useContractDetailsPopup()

  const { details } = contractDetailsContext.state
  const { getContractDetailsAsync } = contractDetailsContext.actions

  const { setState, close } = terminateContractPopup.actions

  const handleClickTerminateContract = useCallback(async () => {
    try {
      dispatch(setLoading(true))
      await updateContractTerminationDateRequestAsync(details.uuid, {
        termination_date: moment().format('YYYY-MM-DD')
      })
      notification.success({
        message: VALIDATION_MESSAGES.SM0009_1
      })
      terminateContractPopup.actions.close()
      await getContractDetailsAsync()
    } catch (e) {
      const err = e as AxiosResponse
      if (err?.data?.termination_date) {
        notification.error({ message: err?.data.termination_date[0] })
      }
      console.error(err)
    } finally {
      dispatch(setLoading(false))
    }
  }, [
    details.uuid,
    dispatch,
    getContractDetailsAsync,
    terminateContractPopup.actions
  ])

  const Footer = useMemo(
    () => (
      <>
        <Button type={BUTTON_TYPES.DEFAULT} onClick={close} upperCase>
          {BTN_TXT.BACK_TO_DETAILS}
        </Button>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          onClick={handleClickTerminateContract}
          danger
          upperCase
        >
          {BTN_TXT.TERMINATE_CONTRACT}
        </Button>
      </>
    ),
    [close, handleClickTerminateContract]
  )

  useLayoutEffect(() => {
    setState((prevState) => ({
      ...prevState
    }))
  }, [details.contract_category_name, setState])

  return (
    <Popup {...terminateContractPopup.state} width={442} footer={Footer}>
      <Typography.Body1>
        You are about to end the contracting process for{' '}
        {details.contract_category_name} with {details.vendor?.name}. The vendor
        and all relevant users will be notified. Please confirm termination.
      </Typography.Body1>
    </Popup>
  )
}
